import styled from "@emotion/styled";
import { ThemeProp } from "../../../styles/theme";
import { motion } from "framer-motion";

export interface NetworkButtonStyledProps extends ThemeProp {
  isDropdownOpen: boolean;
}
export const NetworkButtonStyled = styled(motion.button)<NetworkButtonStyledProps>(
  ({ theme, isDropdownOpen }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: 0,
    background: isDropdownOpen ? theme.theme[700] : "none",
    color: theme.font.primary.default,
    fontFamily: theme.fontFamilies.Primary,
    fontWeight: theme.fontWeights["work-sans-0"],
    borderRadius: "16px",
    gap: "5px",
    ":hover": {
      background: theme.theme[700],
    },
    lineHeight: theme.lineHeights["3"],
    padding: "4px 8px 4px 8px",
    transition: "0.3s",
    position: "relative",
  })
);
